// Toggle the mobile menu open and closed
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');

    if (!burgerButton) {
        return;
    }

    burgerButton.addEventListener('click', function () {
        const isOpen = document.body.classList.toggle('gh-head-open');
        burgerButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
}
